module.exports = __webpack_public_path__ + "static/media/penna nera.e913aef6.png";